export const NAME = "addNote";
export const MODAL_NAME = "addNoteModal";
